/** S10.2 — a project's fair-use rejections are worth a hint once they exceed
 *  this many for the day (matches the backend's REPEATED_THRESHOLD,
 *  apps/api/src/lib/fair-use.ts). Shared by the projects list (`Projects.tsx`)
 *  and the project overview tab (`project-tabs.tsx`) so the threshold lives
 *  in exactly one place (F4). */
export const FAIR_USE_HINT_THRESHOLD = 3;

export function isFairUseHintDue(rejectionsToday: number): boolean {
  return rejectionsToday > FAIR_USE_HINT_THRESHOLD;
}
